









import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ProductDocumentationPublic from '@/components/ProductDocumentationPublic.vue';


@Component({

    components: {
        ProductDocumentationPublic
    }
})
export default class ProductDocumentationPublicPage extends Vue {
    productCode: string = '';
    mounted() {
        this.productCode = this.$route.params.productCode;
       
    }
}
